import {createTheme} from '@mui/material/styles';
import {
    FuelFontWeightSemibold, FuelFontFamilyBase, FuelFontSizeHeading1,
    FuelLineHeight2xl, FuelFontSizeHeading2, FuelShadowMd, FuelShadowLg,
    FuelShadowXl, FuelShadow2xl, FuelLineHeightXl, FuelFontSizeHeading3,
    FuelLineHeightSm, FuelFontSizeHeading4, FuelFontSizeHeading5, FuelFontSizeHeading6,
    FuelLineHeightMd, FuelFontSizeMd, FuelColorTextTertiary, FuelFontSizeXs,
    FuelLineHeightXs, FuelFontSizeSm, FuelFontWeightRegular
} from '@deere/fuel-tokens/dist/web/jd-green/tokens';
import {CSSProperties} from 'react';

export const baseTheme = createTheme({
    typography: {
        fontFamily: FuelFontFamilyBase,
        fontWeightMedium: FuelFontWeightSemibold as CSSProperties['fontWeight'],
        h1: {
            fontWeight: FuelFontWeightSemibold as CSSProperties['fontWeight'],
            fontSize: FuelFontSizeHeading1,
            lineHeight: FuelLineHeight2xl
        },
        h2: {
            fontWeight: FuelFontWeightSemibold as CSSProperties['fontWeight'],
            fontSize: FuelFontSizeHeading2,
            lineHeight: FuelLineHeightXl
        },
        h3: {
            fontWeight: FuelFontWeightSemibold as CSSProperties['fontWeight'],
            fontSize: FuelFontSizeHeading3,
            lineHeight: FuelLineHeightXl
        },
        h4: {
            fontWeight: FuelFontWeightSemibold as CSSProperties['fontWeight'],
            fontSize: FuelFontSizeHeading4,
            lineHeight: FuelLineHeightMd
        },
        h5: {
            fontWeight: FuelFontWeightSemibold as CSSProperties['fontWeight'],
            fontSize: FuelFontSizeHeading5,
            lineHeight: FuelLineHeightSm
        },
        h6: {
            fontWeight: FuelFontWeightSemibold as CSSProperties['fontWeight'],
            fontSize: FuelFontSizeHeading6,
            lineHeight: FuelLineHeightSm
        },
        body1: {
            fontSize: FuelFontSizeMd
        },
        subtitle1: {
            color: FuelColorTextTertiary,
            fontWeight: FuelFontWeightSemibold as CSSProperties['fontWeight'],
            fontSize: FuelFontSizeSm,
            lineHeight: FuelLineHeightSm
        },
        subtitle2: {
            fontWeight: FuelFontWeightSemibold as CSSProperties['fontWeight'],
            color: FuelColorTextTertiary,
            fontSize: FuelFontSizeXs,
            lineHeight: FuelLineHeightXs
        },
        button: {
            textTransform: 'none',
            fontSize: FuelFontSizeSm,
            lineHeight: FuelLineHeightMd,
            fontWeight: FuelFontWeightSemibold as CSSProperties['fontWeight']
        },
        caption: {
            fontSize: FuelFontSizeXs,
            lineHeight: FuelLineHeightXs,
            fontWeight: FuelFontWeightRegular as CSSProperties['fontWeight']
        },
        overline: {
            fontSize: FuelFontSizeXs,
            lineHeight: FuelLineHeightXs,
            fontWeight: FuelFontWeightRegular as CSSProperties['fontWeight']
        }
    },
    shape: {
        borderRadius: 4
    },
    spacing: (factor: number) => `${0.25 * factor}rem`,
    shadows: [
        'none',
        FuelShadowMd,
        FuelShadowMd,
        FuelShadowMd,
        FuelShadowMd,
        FuelShadowLg,
        FuelShadowLg,
        FuelShadowLg,
        FuelShadowXl,
        FuelShadowXl,
        FuelShadowXl,
        FuelShadowXl,
        FuelShadowXl,
        FuelShadowXl,
        FuelShadowXl,
        FuelShadowXl,
        FuelShadow2xl,
        FuelShadow2xl,
        FuelShadow2xl,
        FuelShadow2xl,
        FuelShadow2xl,
        FuelShadow2xl,
        FuelShadow2xl,
        FuelShadow2xl,
        FuelShadow2xl
    ]
} as any);
